module.exports = __webpack_public_path__ + "static/media/click1.d8e2f3b9.ogg";